import React from 'react'
import { useS4LContext } from '@s4l/react-context'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import { Devices, useBrowser } from '@s4l/utils/hooks/useBrowser'

import { Typography } from '@s4l/ds'
import StoreDownloadButton, { STORE_URLS } from '../StoreDownloadButton'

import styles from './index.module.css'

const LOGO_IMAGE = 'https://static.stayforlong.com/web/images/260116-stayforlong-square-logo.png'
const QR_CODE = 'https://static.stayforlong.com/web/images/260120-s4l-qr.svg'

export interface VoucherAppBannerProps {
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
}

function VoucherAppBanner({ onClick }: VoucherAppBannerProps) {
  const { i18n } = useS4LContext()
  const { isAppleDevice, device } = useBrowser()

  if (isAppleDevice) return null

  const isMobile = device === Devices.Mobile
  const titleProps = isMobile
    ? ({ variant: 'body', size: 'xl' } as const)
    : ({ variant: 'title', size: 'xs' } as const)

  return (
    <a
      className={styles.banner}
      data-testid="voucher-app-banner"
      href={STORE_URLS.googlePlay}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      <img alt="Stayforlong logo" src={LOGO_IMAGE} className={styles.logo} />

      <div className={styles.content}>
        <div className={styles.textContent}>
          <Typography as="p" bold color="var(--color-neutral-900)" {...titleProps}>
            {i18n.formatMessage({ id: 'app-banner.title' })}
          </Typography>
          <Typography as="p" color="var(--color-neutral-900)" variant="caption" size="l">
            {i18n.formatMessage({ id: 'app-banner.body' })}
          </Typography>
        </div>
        <StoreDownloadButton store="googlePlay" theme="dark" />
      </div>

      <img
        alt={i18n.formatMessage({ id: 'app-banner.qr-action' })}
        src={QR_CODE}
        className={styles.qrContainer}
      />
    </a>
  )
}

VoucherAppBanner.displayName = 'VoucherAppBanner'
export default withErrorBoundary(VoucherAppBanner)
